import { Popover, TableRow as MUITableRow } from '@mui/material';
import moment from 'moment-timezone';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import UploadIcon from '../../../assets/svg/UploadIcon';
import {
  AI_PROMPT_FEATURES,
  DATE_TIME_FORMAT,
  ROUTE_MAP,
} from '../../../constants';
import { Icon, IconButton, TableBodyCell } from '../../Shared';
import { FeatureCell } from './FeatureCell';

export const TableRow = ({
  client,
  withBorderBottom,
  onOpenPrompt,
  onChangeStatus,
}) => {
  const { tenantId, tenantName, contactsTotal, contactsWithData, lastUpdated } =
    client;

  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = useState(null);

  const coverage = contactsTotal
    ? Math.round((contactsWithData / contactsTotal) * 100)
    : 0;

  return (
    <MUITableRow>
      <TableBodyCell
        withBorderBottom={withBorderBottom}
        width="140px"
        title={tenantName}
      >
        {tenantName}
      </TableBodyCell>
      {AI_PROMPT_FEATURES.map(feature => (
        <FeatureCell
          key={feature.key}
          client={client}
          feature={feature}
          withBorderBottom={withBorderBottom}
          onOpenPrompt={onOpenPrompt}
          onChangeStatus={onChangeStatus}
        />
      ))}
      <TableBodyCell withBorderBottom={withBorderBottom} width="192px">
        <div className="flex flex-col gap-1">
          <div className="h-1.5 rounded-full bg-base-200 overflow-hidden">
            <div
              className="h-full rounded-full bg-brand-300"
              style={{ width: `${coverage}%` }}
            />
          </div>
          <span className="text-base-800 text-[13px]/[18px]">
            {contactsWithData.toLocaleString('en-US')} of{' '}
            {contactsTotal.toLocaleString('en-US')} · {coverage}%
          </span>
        </div>
      </TableBodyCell>
      <TableBodyCell withBorderBottom={withBorderBottom} width="136px">
        {lastUpdated
          ? moment(lastUpdated).format(DATE_TIME_FORMAT.MMM_D_YYYY)
          : '-'}
      </TableBodyCell>
      <TableBodyCell
        align="center"
        withBorderBottom={withBorderBottom}
        width="56px"
      >
        <IconButton
          buttonProps={{
            className: 'w-8 h-8',
            'aria-label': `Actions for ${tenantName}`,
            onClick: e => setAnchorEl(e.currentTarget),
          }}
          iconProps={{ name: 'dots', className: 'h-6' }}
        />
        <Popover
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          slotProps={{
            paper: {
              className:
                '!rounded-xl mt-1 !shadow-[0_4px_20px_0_rgba(17,17,58,0.08)] bg-white w-[300px]',
            },
          }}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          <div className="p-0.5 flex flex-col gap-0.5">
            {AI_PROMPT_FEATURES.map(feature => (
              <button
                key={feature.key}
                type="button"
                className="flex items-center gap-2 py-1.5 px-2 text-left rounded-lg hover:bg-base-700"
                onClick={() => {
                  setAnchorEl(null);
                  onOpenPrompt(client, feature, false);
                }}
              >
                <Icon name="edit" className="w-4 h-4" />
                <span className="font-medium text-[14px]/[20px] text-base-1000">
                  {client[feature.key].hasPrompt ? 'Edit' : 'Add'}{' '}
                  {feature.name} prompt
                </span>
              </button>
            ))}
            <button
              type="button"
              className="flex items-center gap-2 py-1.5 px-2 text-left rounded-lg hover:bg-base-700"
              onClick={() => {
                navigate(ROUTE_MAP.AIDENTIFIED_DATA, {
                  state: { uploadForTenantId: tenantId },
                });
              }}
            >
              <UploadIcon className="w-4 h-4 text-brand-900" />
              <span className="font-medium text-[14px]/[20px] text-base-1000">
                Upload Aidentified data
              </span>
            </button>
          </div>
        </Popover>
      </TableBodyCell>
    </MUITableRow>
  );
};
